import {
  Area,
  Cell,
  CellPosition,
  CellReference,
  Cells,
  CellsReferences,
} from '../../types';
import { getCell } from './cellCRUD';

interface Configs {
  considerEmpty?: boolean;
}

export interface IterateCellCBParam<T extends Cells | CellsReferences> {
  cell?: T[number][number];
  position: CellPosition;
}

type IterateCellCallback<T extends Cells | CellsReferences> = (
  params: IterateCellCBParam<T>
) => Promise<void>;

export const iterateCells = async <T extends Cells | CellsReferences>(
  cells: T,
  area: Area,
  cb: IterateCellCallback<T>,
  configs: Configs = {}
) => {
  const rowMax = Math.min(area.end.ri, cells.length - 1);
  const rowStart = area.start.ri; // Math.max(Math.min(area.start.ri, rowMax), 0);

  const { considerEmpty } = configs;
  for (let ri = rowStart; ri <= rowMax; ri++) {
    const cols = cells[ri];

    if (!considerEmpty && (!cols || !cols?.length)) continue;

    const colsMax = Math.min(area.end.ci, cols.length - 1);
    const colStart = area.start.ci;

    for (let ci = colStart; ci <= colsMax; ci++) {
      const position = {
        ci,
        ri,
      };
      const cell = getCell(cells, position);
      await cb({ cell, position });
    }
  }
};
